import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

export type PartFeaturesBulkDto = ClientInferResponseBody<typeof contract.parts.findBulkFeatures>;

export const fetchPartFeaturesBulk = async ({
  partIds,
}: {
  partIds: string[];
}): Promise<PartFeaturesBulkDto> => {
  if (partIds.length === 0) {
    return {};
  }

  const response = await api.parts.findBulkFeatures.mutation({
    body: {
      partIds,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return {};
};
